import { Api, Auth } from '~/services';

import {
	getUpcomingEvents as _getUpcomingEvents
} from '../api/events';

export function getUpcomingEvents() {
	return ( dispatch, getStore ) => {
		return dispatch(
			async dispatch => {

				dispatch({
					type: 'REQUEST_EVENTS'
				});

				const events = await _getUpcomingEvents();

                dispatch({
                    type: 'RECEIVE_EVENTS',
                    events,
                });
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/actions/events.js